import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://4jbhzumjk7.execute-api.us-east-2.amazonaws.com/prod';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface Ticket {
  caseNumber: string;
  subject: string;
  description: string;
  category: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export const supportService = {
  async submitTicket(
    subject: string,
    description: string,
    category: string,
    token: string
  ) {
    const response = await api.post(
      '/support/tickets',
      { subject, description, category },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  async getTickets(token: string) {
    const response = await api.get('/support/tickets', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async chat(message: string, history: ChatMessage[], token: string) {
    const response = await api.post(
      '/support/chat',
      { message, history },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 60000,
      }
    );
    return response.data;
  },
};
